import React, { useEffect } from "react";
import { EVENTS } from "../config";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const Videos = ({ socket, peer }) => {
  console.log("rendered");
  let myVideoRef = React.createRef();
  let rootRef = React.createRef();
  useEffect(() => {
    window.navigator.mediaDevices
      .getUserMedia({
        video: true,
        audio: true,
      })
      .then(
        (stream) => {
          myVideoRef.current.muted = true;
          myVideoRef.current.srcObject = stream;
          myVideoRef.current.play();

          const handleCall = (call) => {
            const video = document.createElement("video");
            call.on("stream", (stream) => {
              video.setAttribute("id", "kk" + call.peer);
              video.setAttribute("class", "video");
              addVideoToRoot(video, stream);
            });
          };
          const addVideoToRoot = (video, stream) => {
            video.srcObject = stream;
            video.addEventListener("loadedmetadata", () => {
              video.play();
            });
            rootRef.current.append(video);
          };
          const removeVideoFromRoot = (userID) => {
            window.document.querySelector(`#kk${userID}`).remove();
          };
          socket.on(EVENTS.USER_JOINED, (userId) => {
            const call = peer.call(userId, stream);
            handleCall(call);
          });
          peer.on("call", (call) => {
            call.answer(stream);
            handleCall(call);
          });
          socket.on(EVENTS.USER_LEFT, (userID) => {
            removeVideoFromRoot(userID);
          });
          socket.on("want-permission", (id) => {
            const options = {
              title: "Permission",
              message: `${id} can join room?`,
              buttons: [
                {
                  label: "Yes",
                  onClick: () => socket.emit("allowed"),
                },
                {
                  label: "No",
                  onClick: () => socket.emit("rejected"),
                },
              ],
            };
            confirmAlert(options);
          });
          socket.on("alert", (msg) => {
            window.alert(msg);
            // window.location.href = "/";
          });
        },
        (err) => {
          window.alert("allow permission to camera and mic", err);
        }
      );
  }, [rootRef, myVideoRef, peer, socket]);
  return (
    <div className="container">
      <div ref={rootRef} className="video-wrapper"></div>
      <video className="My-video" ref={myVideoRef}></video>
    </div>
  );
};
export default Videos;
